import { render, staticRenderFns } from "./fangInfo.vue?vue&type=template&id=0a126649"
import script from "./fangInfo.vue?vue&type=script&lang=js"
export * from "./fangInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports